<tn-dialog-shell [testId]="error.testId || 'error'" [title]="error.title | translate">
  <div id="err-md-content" class="err-content" role="alertdialog">
    <div class="err-message-wrapper">
      <span tnTestIdType="text" [tnTestId]="'error-message'" [innerHTML]="error.message"></span>
      @if (error.hint) {
        <div class="hint-text">
          <tn-icon name="information" library="mdi" class="hint-icon"></tn-icon>
          <span tnTestId="error-hint" tnTestIdType="text">{{ error.hint | translate }}</span>
        </div>
      }
    </div>

    @if (error.details && error.details.length > 0) {
      <a
        class="more-info"
        role="button"
        tabindex="0"
        tnTestIdType="link"
        [tnTestId]="'view-details'"
        [attr.aria-expanded]="isDetailsOpen()"
        (click)="toggleDetails()"
        (keydown.enter)="toggleDetails()"
        (keydown.space)="$event.preventDefault(); toggleDetails()"
      >
        @if (isDetailsOpen()) {
          <tn-icon name="minus-circle-outline" library="mdi"></tn-icon>
        } @else {
          <tn-icon name="plus-circle-outline" library="mdi"></tn-icon>
        }
        <span>{{ 'View Details' | translate }}</span>
      </a>

      <div
        class="details-panel"
        [class.open]="isDetailsOpen()"
      >
        <div class="details-content">
          <table class="details-table">
            @for (detail of error.details; track detail.label) {
              <tr>
                <td class="detail-label" tnTestIdType="text" [tnTestId]="['error-detail-label', detail.label]">{{ detail.label }}:</td>
                <td class="detail-value">
                  @if (isCollapsibleDetail(detail.label)) {
                    @if (!isDetailExpanded(detail.label)) {
                      <a
                        class="trace-toggle"
                        role="button"
                        tabindex="0"
                        tnTestIdType="link"
                        [attr.aria-expanded]="false"
                        [tnTestId]="['show-detail', detail.label]"
                        (click)="toggleDetailExpanded(detail.label)"
                        (keydown.enter)="toggleDetailExpanded(detail.label)"
                        (keydown.space)="$event.preventDefault(); toggleDetailExpanded(detail.label)"
                      >
                        <tn-icon name="eye" library="mdi" customSize="18px"></tn-icon>
                        <span>{{ 'Show' | translate }}</span>
                      </a>
                    } @else {
                      <a
                        class="trace-toggle"
                        role="button"
                        tabindex="0"
                        tnTestIdType="link"
                        [attr.aria-expanded]="true"
                        [tnTestId]="['hide-detail', detail.label]"
                        (click)="toggleDetailExpanded(detail.label)"
                        (keydown.enter)="toggleDetailExpanded(detail.label)"
                        (keydown.space)="$event.preventDefault(); toggleDetailExpanded(detail.label)"
                      >
                        <tn-icon name="eye-off" library="mdi" customSize="18px"></tn-icon>
                        <span>{{ 'Hide' | translate }}</span>
                      </a>
                      <pre tnTestIdType="text" [tnTestId]="['error-detail', detail.label]">{{ detail.value }}</pre>
                    }
                  } @else if (detail.value && detail.value.toString().includes('\n')) {
                    <pre tnTestIdType="text" [tnTestId]="['error-detail', detail.label]">{{ detail.value }}</pre>
                  } @else {
                    <span tnTestIdType="text" [tnTestId]="['error-detail', detail.label]">{{ detail.value || 'N/A' }}</span>
                  }
                </td>
              </tr>
            }
          </table>
        </div>

        <ix-copy-button [text]="getDetailsAsText()"></ix-copy-button>
      </div>
    }
  </div>

  <div tnDialogAction>
    <tn-button
      variant="outline"
      testId="close-error-dialog"
      [label]="'Close' | translate"
      (onClick)="dialogRef.close(true)"
    ></tn-button>

    @if (error.logs) {
      <tn-button
        testId="download-logs"
        [label]="'Download Logs' | translate"
        (onClick)="downloadLogs()"
      ></tn-button>
    }

    @for (action of error.actions; track action.label) {
      <tn-button
        [testId]="'action-' + action.label"
        [label]="action.label | translate"
        (onClick)="handleAction(action)"
      ></tn-button>
    }
  </div>
</tn-dialog-shell>
